/**
 * @author: Marcos Cordo
 * @version: 16/05/2026_PB (Punto B: eliminados type y department directos — se leen vía project.type/department)
 */
import { BaseModel } from './base.model';
import { Project } from './project.model';
import { User } from './user.model';
import { Requirement } from './requirement.model';
import { EstimationMetadata, EstimationRollup } from './estimation-v3.types';
import { System } from './system.model';

export interface Estimation {
  id: number;
  name: string;
  createdate: string;
  requirements: Requirement[];
  project: Project;
  user: User;
  prompt: string;

  // ===== Bloques v3 (opcionales para retrocompatibilidad) =====
  metadata?: EstimationMetadata;
  metadata_original?: EstimationMetadata;
  rollup?: EstimationRollup;

  // Sistemas elegidos durante el wizard de creación (in-flight, no persistido en estimation).
  systems?: System[];
}

export class Estimation implements BaseModel {
  id: number;
  name: string;
  createdate: string;
  requirements: Requirement[];
  project: Project;
  user: User;
  prompt: string;

  // v3
  metadata?: EstimationMetadata;
  metadata_original?: EstimationMetadata;
  rollup?: EstimationRollup;

  systems?: System[];

  constructor();
  constructor(id: number, name: string, createdate: string, requirements: Requirement[], project: Project, user: User, prompt: string);

  constructor(id?: number, name?: string, createdate?: string, requirements?: Requirement[], project?: Project, user?: User, prompt?: string) {
    if (id !== undefined) {
      this.id = id;
    }

    if (name !== undefined) {
      this.name = name;
    } else {
      this.name = '';
    }

    if (createdate !== undefined) {
      this.createdate = createdate;
    } else {
      this.createdate = '';
    }

    if (requirements !== undefined) {
      this.requirements = requirements;
    } else {
      this.requirements = [];
    }

    // Punto B: project se inicializa como new Project() para que project.type
    // y project.department existan con valores vacíos seguros desde el inicio.
    if (project !== undefined) {
      this.project = project;
    } else {
      this.project = new Project();
    }

    if (user !== undefined) {
      this.user = user;
    } else {
      this.user = {} as User;
    }

    if (prompt !== undefined) {
      this.prompt = prompt;
    } else {
      this.prompt = '';
    }

    this.systems = [];
  }

  getApiName(): string {
    return 'estimations';
  }

  getName(): string {
    return 'Estimación';
  }

  getNamePl(): string {
    return 'Estimaciones';
  }
}